/* Apre la chat dell'assistente AI (widget Keplero) cliccando il suo pulsante nello shadow DOM. */
export function openAiChat(attempt = 0) {
  const el = document.querySelector("kepleroai-chat");
  const btn = el && el.shadowRoot && el.shadowRoot.querySelector('button[aria-label="Apri chat"]');
  if (btn) {
    btn.click();
    return;
  }
  /* Widget non ancora montato (o chat gia' aperta): riprova poco dopo. */
  if (attempt < 4) setTimeout(() => openAiChat(attempt + 1), 350);
}

/* Accessibilita' widget: l'input file interno (1x1px) esce dall'albero
   accessibile (aria-hidden) senza togliere funzionalita' all'upload. */
function hideWidgetFileInput() {
  const el = document.querySelector("kepleroai-chat");
  if (!el || !el.shadowRoot) return false;
  const inp = el.shadowRoot.querySelector('input[type="file"]');
  if (inp) inp.setAttribute("aria-hidden", "true");
  return !!inp;
}

export function fixWidgetA11y() {
  let n = 0;
  const t = setInterval(() => {
    n += 1;
    if (hideWidgetFileInput() || n > 30) clearInterval(t);
  }, 500);
  return () => clearInterval(t);
}
